export default __webpack_public_path__ + "static/media/case-study-1-digital-airfield.f0328872.mp4";